import { useEffect, useRef } from "react";
import gsap from "gsap";

/**
 * Minimal top/bottom chrome frame around the workspace — brand mark, small studio meta.
 * Kept extremely light per the "no bento / no SaaS" directive.
 */
export function Chrome() {
  const topRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (topRef.current) {
      gsap.fromTo(topRef.current, { y: -12, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: "power2.out", delay: 0.2 });
    }
    if (bottomRef.current) {
      gsap.fromTo(bottomRef.current, { y: 12, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: "power2.out", delay: 0.5 });
    }
  }, []);

  return (
    <>
      <header
        ref={topRef}
        className="pointer-events-none fixed top-0 inset-x-0 z-30 flex items-center justify-between px-6 md:px-10 py-5"
      >
        <h1
          className="font-mono-caps text-foreground-100 pointer-events-auto"
          style={{ letterSpacing: "0.32em", fontSize: "12px" }}
        >
          <a href="/" className="cursor-pointer">POTTERY MAKING</a>
        </h1>
        <div className="hidden md:flex items-center gap-6 pointer-events-auto">
          <p className="font-mono-caps text-foreground-500" style={{ fontSize: "10px" }}>
            Studio · Wheel 01
          </p>
          <p className="font-mono-caps text-foreground-500" style={{ fontSize: "10px" }}>
            Session {new Date().toLocaleDateString(undefined, { month: "short", day: "2-digit" })}
          </p>
        </div>
      </header>

      <footer
        ref={bottomRef}
        className="pointer-events-none fixed bottom-0 inset-x-0 z-20 flex items-center justify-between px-6 md:px-10 py-5"
      >
        <p className="font-mono-caps text-foreground-500" style={{ fontSize: "10px" }}>
          You are at the wheel
        </p>
        <p className="hidden md:block font-mono-caps text-foreground-500" style={{ fontSize: "10px" }}>
          ⌘Z Undo · 1 2 3 4 Tools · [ ] Speed · + − Fingertip
        </p>
      </footer>
    </>
  );
}